import { z } from 'zod';
import { ChannelSchema, VersionStringSchema, ConfigurationStatusSchema, FieldValueSchema } from './schema';
import { EnrichmentFieldConfigurationSchema } from './enrichment';
import { ScheduleSchema, VariantSchema } from './variant';
export const SelectionGroupSchema = z.lazy(() => z.object({
    key: z.string(),
    label: z.string(),
    default: ModuleConfigurationSchema.optional(),
    schedule: ScheduleSchema.optional(),
    selections: z.array(VariantSchema)
}));
export const ZoneConfigurationSchema = z.array(SelectionGroupSchema);
export const ModuleConfigurationSchema = z.object({
    type: z.string(),
    key: z.string(),
    locale: z.string(),
    label: z.string(),
    description: z.string().optional(),
    channel: ChannelSchema,
    definitionVersion: VersionStringSchema,
    revision: z.number(),
    status: ConfigurationStatusSchema,
    fields: z.record(z.string(), FieldValueSchema),
    enrichmentFields: z
        .record(z.string(), EnrichmentFieldConfigurationSchema)
        .optional(),
    zones: z.record(z.string(), ZoneConfigurationSchema).optional()
});
export const SurfaceConfigurationSchema = ModuleConfigurationSchema;
/**
 * Create a surface from a surface configuration json.
 * @param configuration Surface configuration json, conforming with SurfaceConfiguration type.
 * @returns - Surface configuration object.
 * @example
 * ```ts
 *    import { createSurfaceConfiguration } from '@atlassiansox/bxp-definition-sdk';
 *
 *    export const ExampleSurface = createSurfaceConfiguration({
 *      {
          "type":"ExampleWebSurface",
          "key":"TestSurfaceV1",
          "locale":"en",
          "label":"Test Surface - v1.0.0",
          "description":"Creating a Test Surface",
          "channel":"web",
          "definitionVersion":"0.0.1",
          "revision":1,
          "status":"published",
          "fields":{
            "title":"Test Surface",
            "description":"Test Surface"
          },
          "zones":{
            "main":[{
                "key": "hello-world-variations",
                "label": "Hello World module variations",
                "default": {
                  "type":"HelloWorld",
                  "key":"HelloWorldV1",
                  "locale":"en",
                  "label":"Hello World Module - v1.0.0",
                  "description":"Hello World Module - v1.0.0",
                  "channel": "web",
                  "definitionVersion":"1.0.0",
                  "revision":1,
                  "status":"published",
                  "fields":{
                    "title":"Test Hello World Module title",
                    "size": 50,
                    "value": "some value"
                  }
                },
                "selections": []
            }]
          }
        }
 *   });
 * ```
 */
export function createSurfaceConfiguration(surfaceConfiguration) {
    return SurfaceConfigurationSchema.parse(surfaceConfiguration);
}
//# sourceMappingURL=module-configuration.js.map